// extracted by mini-css-extract-plugin
module.exports = {"color-accent":"var(--dynamic-colour)"};